import { defineMessages, IntlShape } from 'react-intl';
import { AccommodationTypeEnum } from '../generated/graphql';

export const accommodationTypeMessages = defineMessages<AccommodationTypeEnum>({
    APARTMENT_BLOCK: {
        defaultMessage: 'Appartementencomplex',
    },
    BED_AND_BREAKFAST: {
        defaultMessage: 'B&B',
    },
    BUNGALOW_PARK: {
        defaultMessage: 'Vakantiepark',
    },
    CAMPING: {
        defaultMessage: 'Camping',
    },
    HOTEL: {
        defaultMessage: 'Hotel',
    },
    LOCATION: {
        defaultMessage: 'Locatie',
    },
});

// TODO: ditch this (frankly kinda useless) function?
const getAccommodationType = (intl: IntlShape, type: AccommodationTypeEnum) =>
    intl.formatMessage(accommodationTypeMessages[type]);

export default getAccommodationType;
